import React, { useState, Component } from 'react';
import { useNavigate } from 'react-router-dom';
import { SearchIcon, MapPinIcon } from 'lucide-react';
import LocationChecker from '../components/LocationChecker';
const HomePage = () => {
  const navigate = useNavigate();
  return <div className="w-full" data-id="element-161">
      {/* Hero Section */}
      <section className="relative bg-teal-50 py-20" data-id="element-162">
        <div className="container mx-auto px-4 md:px-6" data-id="element-163">
          <div className="flex flex-col md:flex-row items-center" data-id="element-164">
            <div className="md:w-1/2 mb-10 md:mb-0" data-id="element-165">
              <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4" data-id="element-166">
                Beauty treatments at your doorstep
              </h1>
              <p className="text-lg text-gray-600 mb-8" data-id="element-167">
                Professional beauty services delivered to your home, office, or
                hotel
              </p>
              {/* Location Checker Component */}
              <LocationChecker data-id="element-168" />
            </div>
            <div className="md:w-1/2" data-id="element-169">
              <img src="https://images.unsplash.com/photo-1616394584738-fc6e612e71b9?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="At-home beauty treatment" className="rounded-lg shadow-lg w-full h-auto" data-id="element-170" />
            </div>
          </div>
        </div>
      </section>
      {/* Popular Services Section */}
      <section className="py-16 bg-white" data-id="element-171">
        <div className="container mx-auto px-4" data-id="element-172">
          <h2 className="text-3xl font-bold text-center mb-12" data-id="element-173">
            Our Popular Services
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-174">
            {popularServices.map(service => <div key={service.id} className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow" data-id="element-175">
                <img src={service.image} alt={service.name} className="w-full h-48 object-cover" data-id="element-176" />
                <div className="p-6" data-id="element-177">
                  <h3 className="text-xl font-semibold mb-2" data-id="element-178">{service.name}</h3>
                  <p className="text-gray-600 mb-4" data-id="element-179">{service.description}</p>
                  <p className="text-teal-600 font-semibold mb-4" data-id="element-180">
                    From £{service.price}
                  </p>
                  <button onClick={() => navigate('/services')} className="w-full bg-teal-600 text-white py-2 rounded-md hover:bg-teal-700 transition-colors" data-id="element-181">
                    Book Now
                  </button>
                </div>
              </div>)}
          </div>
        </div>
      </section>
      {/* How It Works Section */}
      <section className="py-16 bg-teal-50" data-id="element-182">
        <div className="container mx-auto px-4" data-id="element-183">
          <h2 className="text-3xl font-bold text-center mb-12" data-id="element-184">How It Works</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center" data-id="element-185">
            <div className="p-6" data-id="element-186">
              <div className="bg-teal-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-187">
                <MapPinIcon className="h-8 w-8 text-teal-600" data-id="element-188" />
              </div>
              <h3 className="text-xl font-semibold mb-2" data-id="element-189">
                Enter Your Location
              </h3>
              <p className="text-gray-600" data-id="element-190">
                Check if we serve your area by entering your postcode
              </p>
            </div>
            <div className="p-6" data-id="element-191">
              <div className="bg-teal-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-192">
                <SearchIcon className="h-8 w-8 text-teal-600" data-id="element-193" />
              </div>
              <h3 className="text-xl font-semibold mb-2" data-id="element-194">
                Choose Your Service
              </h3>
              <p className="text-gray-600" data-id="element-195">
                Browse our range of professional beauty treatments
              </p>
            </div>
            <div className="p-6" data-id="element-196">
              <div className="bg-teal-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-197">
                <svg className="h-8 w-8 text-teal-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-198">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" data-id="element-199" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold mb-2" data-id="element-200">
                Book Your Appointment
              </h3>
              <p className="text-gray-600" data-id="element-201">
                Select your preferred therapist and time slot
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>;
};
// Sample data
const popularServices = [{
  id: 1,
  name: 'Manicure & Pedicure',
  description: 'Luxury nail treatment for hands and feet',
  price: 45,
  image: 'https://images.unsplash.com/photo-1604654894610-df63bc536371?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
}, {
  id: 2,
  name: 'Massage Therapy',
  description: 'Relaxing full body massage',
  price: 65,
  image: 'https://images.unsplash.com/photo-1600334129128-685c5582fd35?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
}, {
  id: 3,
  name: 'Facial Treatment',
  description: 'Rejuvenating facial for glowing skin',
  price: 55,
  image: 'https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
}];
export default HomePage;